import React, { useState } from 'react'
import TextField from '@material-ui/core/TextField'
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  FormControlLabel,
  Typography
} from '@material-ui/core'
import AccessTypeSelector from 'elements/AccessTypeSelector/AccessTypeSelector'
import QuickAccessButton from 'elements/QuickAccessButton/QuickAccessButton'
import QuickAccessModal from 'elements/QuickAccessModal/QuickAccessModal'
import { AccessTypeLabels, RelativePathByAccessType } from 'shared/constants'
import styles from './ClientForm.module.css'

function ClientForm({ client }) {
  const { activo, email, cliente } = client || {}
  const [showQuickAccessModal, setShowQuickAccessModal] = useState(false)
  const [quickAccessUrl, setQuickAccessUrl] = useState('')

  const handleCloseModal = () => {
    setShowQuickAccessModal(false)
    setQuickAccessUrl('')
  }

  const handleQuickAccessGenerated = url => {
    setQuickAccessUrl(url)
    setShowQuickAccessModal(true)
  }

  return (
    <Card variant='outlined' className={styles.card}>
      <CardHeader
        title={`Ficha ${AccessTypeLabels[cliente?.accessType]}`}
        action={
          <div className={styles.cardActions}>
            <Typography variant='button' component={Button}>
              <a
                href={`https://agora.mundoestudiante.cloud/${
                  RelativePathByAccessType[cliente?.accessType]
                }/${cliente.id}/ficha`}
                target='_blank'
              >
                Ver {AccessTypeLabels[cliente?.accessType]} en Ágora
              </a>
            </Typography>
            <QuickAccessButton
              clientId={cliente?.id}
              onQuickAccessGenerated={handleQuickAccessGenerated}
              disabled={!cliente?.id}
            />
          </div>
        }
      />
      <CardContent className={styles.content}>
        <TextField label='Nombre' value={cliente.name || ''} fullWidth />
        <TextField
          margin='normal'
          label='Correo electrónico'
          value={email || ''}
          fullWidth
        />

        <AccessTypeSelector
          value={cliente.accessType || ''}
          disabled
          fullWidth
        />

        <FormControlLabel
          control={<Checkbox name='active' checked={!!activo} />}
          label='Activo'
        />
      </CardContent>

      <QuickAccessModal
        open={showQuickAccessModal}
        quickAccessUrl={quickAccessUrl}
        onClose={handleCloseModal}
      />
    </Card>
  )
}

export default ClientForm
